export default "__VITE_ASSET__DbGZI34I__"